import React from "react";
import CSVReader from 'react-csv-reader'
import {CSVLink} from 'react-csv'
import {Button, Card, Col, DatePicker, Form, Icon, Input, message, Modal, Row, Select, Spin, Table, Tooltip} from 'antd'
import {API, Auth, Storage} from "aws-amplify"
import "../../Styles/Services/checkInvoiceCSV.css"
import {connect} from "react-redux";
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors";
import {withRouter} from "react-router-dom";
import moment from "moment";
import {CustomSpinner} from "../../Components/Spin/CustomSpiner";
import InvoiceTable from "../../Components/Invoices/InvoiceTable";
import BaseAdminLite from "./BaseAdminLite";
import locale from "antd/es/date-picker/locale/es_ES";

const {Option} = Select;
var interval = null
var count = 0

class LoadInvoicesBatch extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            step: 'batchList',
            loteIdView: null,
            nuevoLoteId: '',
            uploadingCsv: false,
            lastBatchId: null,
            lastUserId: null,
            lastInvoiceId: null,
            downloadedCSV: [],
            enableUpload: true,
            pagination: {},
            data: null,
            lote: [],
            csv: [],
            lotes: [],
            periodo: new Date().getMonth(),
            year: new Date().getUTCFullYear(),
            years: [new Date().getUTCFullYear() - 1, new Date().getUTCFullYear()],
            fechaInicio: null,
            fechaFin: null,
            fechaFactura: null,
            name: '',
            selectedKeys: [],
            modalVisible: false,
            modalBajarFacturasVisible: false,
            loadingBajarFacturas: false,
            fechaInicioBajarFacturas: null,
            fechaFinBajarFacturas: null,
            indexEditing: null,
            recordEditing: null,
            estado: 'EMITTED'
        }
    }


    csvHeaders = [
        {
            label: 'CUIT emisor', title: 'CUIT emisor', key: 'cuit_emisor', dataIndex: 'cuit_emisor',
        },
        {
            label: 'Tipo de Factura',
            title: 'Tipo de Factura',
            key: 'tipo_factura',
            dataIndex: 'tipo_factura',
        },
        {
            label: 'Observaciones',
            title: 'Observaciones',
            key: 'observaciones',
            dataIndex: 'observaciones',
        },
        {
            label: 'Forma de pago', title: 'Forma de pago', key: 'forma_pago', dataIndex: 'forma_pago',
        },
        {
            label: 'Concepto 1', title: 'Concepto 1', key: 'concepto1', dataIndex: 'concepto1',
        },
        {
            label: 'Monto 1', title: 'Monto 1', key: 'monto1', dataIndex: 'monto1',
        },
        {
            label: 'Concepto 2', title: 'Concepto 2', key: 'concepto2', dataIndex: 'concepto2',
        },
        {
            label: 'Monto 2', title: 'Monto 2', key: 'monto2', dataIndex: 'monto2',
        },
        {
            label: 'Concepto 3', title: 'Concepto 2', key: 'concepto3', dataIndex: 'concepto3',
        },
        {
            label: 'Monto 3', title: 'Monto 3', key: 'monto3', dataIndex: 'monto3',
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record, index) => {
                return {
                    children: <>
                        <Button onClick={() => {
                            console.log(record);
                            this.setState({
                                modalVisible: true,
                                indexEditing: index,
                                recordEditing: record
                            })
                        }}>
                            Editar
                        </Button>
                    </>
                }
            }
        }

    ];

    getStringFilterProps = (property) => {
        return {
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <div style={{padding: 8}}>
                    <Input
                        ref={node => {
                            this.searchInput = node;
                        }}
                        placeholder="Buscar"
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        icon="search"
                        size="small"
                        style={{width: 90, marginRight: 8}}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters()}
                        size="small"
                        style={{width: 90}}
                    >
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
            ),
            onFilter: (value, record) => record[property].toString().toLowerCase().includes(value),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select())
                }
            }
        }
    }


    getDateFilterProps = (property) => {
        return {
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <div style={{padding: 8}}>
                    <DatePicker
                        placeholder={"Desde"}
                        value={selectedKeys[0] ? selectedKeys[0].from : null}
                        format="DD-MM-YYYY"
                        locale={locale}
                        disabledDate={d => !d || (selectedKeys[0] != null && d.isAfter(selectedKeys[0].to))}
                        onChange={e => setSelectedKeys([{from: e, to: (selectedKeys[0] ? selectedKeys[0].to : null)}])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                        allowClear={true}
                    />
                    <DatePicker
                        placeholder={"Hasta"}
                        disabledDate={d => !d || (selectedKeys[0] != null && d.isBefore(selectedKeys[0].from))}
                        value={selectedKeys[0] ? selectedKeys[0].to : null}
                        format="DD-MM-YYYY"
                        locale={locale}
                        onChange={e => setSelectedKeys([{
                            to: e,
                            from: (selectedKeys[0] ? selectedKeys[0].from : null)
                        }])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                        allowClear={true}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        icon="search"
                        size="small"
                        style={{width: 90, marginRight: 8}}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters()}
                        size="small"
                        style={{width: 90}}
                    >
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
            ),
            onFilter: (value, record) => {
                const date = moment(record[property], 'YYYY-MM-DD');
                console.log({value, date})
                return date.isValid() && date.isAfter(value.from) && date.isBefore(value.to) || date.isSame(value.to) || date.isSame(value.from);
            }
        }
    }


    toggleProcesar = (record, index) => {
        const state = {...this.state};
        state.csv[index].procesar = !state.csv[index].procesar
        this.setState(state);
    }

    /*
    nombre,  fecha de creación ,   Mes, total ,  procesadas,  aprobadas,  fecha desde y hasta de servicio de factura
     */
    columns = [
        {
            title: 'Nombre',
            key: 'name',
            dataIndex: 'name',
            ...this.getStringFilterProps('name')
        },
        {
            title: 'Fecha creacion',
            key: 'fecha_creacion',
            dataIndex: 'fecha_creacion',
            render: (value, row, index) => {
                return {
                    children: value ? moment(value).format("YYYY-MM-DD") : ''
                }
            },
            sorter: (a, b) => (a.fecha_creacion && b.fecha_creacion) ? moment(a.fecha_creacion, 'YYYY-MM-DD').diff(moment(b.fecha_creacion, 'YYYY-MM-DD'), 'days') : 1,
            defaultSortOrder: 'descend'
        },
        {
            title: 'Mes',
            key: 'mes',
            dataIndex: 'mes',
            ...this.getStringFilterProps('mes')

        },
        {
            title: 'Total',
            key: 'total',
            dataIndex: 'total'
        },
        {
            title: 'Procesadas',
            key: 'processed',
            dataIndex: 'processed'
        },
        {
            title: 'Aprobadas',
            key: 'approved',
            dataIndex: 'approved'
        },
        {
            title: 'Servicio desde',
            key: 'fecha_inicio',
            dataIndex: 'fecha_inicio',
            render: (value, row, index) => {
                return {
                    children: value ? moment(value).format("YYYY-MM-DD") : ''
                }
            },
            sorter: (a, b) => moment(a.fecha_inicio).diff(b.fecha_inicio),
            defaultSortOrder: 'descend',
            ...this.getDateFilterProps('fecha_inicio')
        },
        {
            title: 'Servicio hasta',
            key: 'fecha_fin',
            dataIndex: 'fecha_fin',
            render: (value, row, index) => {
                return {
                    children: value ? moment(value).format("YYYY-MM-DD") : ''
                }
            },
            sorter: (a, b) => moment(a.fecha_fin).diff(b.fecha_fin),
            defaultSortOrder: 'descend',
            ...this.getDateFilterProps('fecha_fin')
        },

        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record, index) => {
                return {
                    children: <>
                        <Button onClick={() => this.invoiceTable(record.batchId)}>
                            Ver
                        </Button>
                        <Button icon="file-excel" onClick={() => this.downloadBatch(record.batchId)}>
                            CSV
                        </Button>
                        <Button icon="file-zip" onClick={() => this.createZip(record.batchId)}>
                            ZIP
                        </Button>
                    </>
                }
            }
        }
    ]

    componentDidMount() {
        this.loadUserData();
        Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]).then(([response, user]) => {
            API.get(
                'test',
                '/root/batch/admin/' + user.username,
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
                .then(response => {
                    console.log(JSON.stringify(response));
                    let batchs = response.batches.map(lote => {
                        lote['key'] = lote['batch_id'];

                        return lote
                    })
                    this.setState({loading: false, lotes: response.batches})
                })
                .catch(err => console.log(err))
        });
    }

    componentWillUnmount() {
        if (interval !== null) {
            clearInterval(interval)
        }
    }

    updateData(field, value) {
        const data = {...this.state}
        data[field] = value
        this.setState({...data})
    }


    newBatch() {
        this.setState({step: 'newBatch'})
    }

    invoiceTable(batch_id) {
        this.setState({loteIdView: batch_id, step: 'batchView'})

    }


    downloadBatch = async (batch_id) => {
        let downloadedCSV = []
        this.setState({loading: true})
        try {
            let response = await Auth.currentSession();
            let queryStringParameters = {
                limit: 200
            }
            while (true) {
                let batch = await API.get(
                    'test',
                    '/root/batch/' + batch_id + '/invoices',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters: queryStringParameters
                    }
                )


                batch.invoices.forEach(inv => {
                    if(inv.items[0]){
                        inv.codigoItem1 = inv.items[0].codigo;
                        inv.descripcionItem1 = inv.items[0].concepto;
                        inv.precioUnitario1 = inv.items[0].precio;
                    }
                    if(inv.items[1]){
                        inv.codigoItem2 = inv.items[1].codigo;
                        inv.descripcionItem2 = inv.items[1].concepto;
                        inv.precioUnitario2 = inv.items[1].precio;
                    }
                    if(inv.items[2]){
                        inv.codigoItem3 = inv.items[2].codigo;
                        inv.descripcionItem3 = inv.items[2].concepto;
                        inv.precioUnitario3 = inv.items[2].precio;
                    }
                })

                if (batch.lastUserId !== null) {
                    queryStringParameters['lastUserId'] = batch.lastUserId
                    queryStringParameters['lastInvoiceId'] = batch.lastInvoiceId


                    batch.invoices.map(inv => {
                        downloadedCSV.push(inv)
                        return inv
                    })
                } else {
                    batch.invoices.map(inv => {
                        downloadedCSV.push(inv)
                        return inv
                    })
                    this.setState({downloadedCSV: downloadedCSV, loading: false, step: "csvDownloaded"})
                    break;
                }
            }
        } catch (err) {
            message.error('No se pudo leer el Lote')
        }
        this.setState({loading: false})
    }


    createZip = (batch_id) => {
        this.setState({loading: true})
        message.config({maxCount: 1})
        message
            .loading('Generando archivos pdf y comprimiendo...', 5)
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/pdf',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters: {
                            batchId: batch_id
                        }
                    }
                )
                    .then(
                        interval = setInterval(this.findZip, 3000, batch_id)
                    )
                    .catch(e => {
                        message.error('No se pudo generar el archivo zip')
                        this.setState({loading: false})
                    })
            })
    }


    findZip = async (batch_id) => {

        try {
            const list = await Storage.list('invoicesBatchZip/')
            if (count < 8) {
                count = count + 1
                list.map(file => {
                        if (file.key === 'invoicesBatchZip/' + batch_id + '.zip') {
                            clearInterval(interval)
                            this.downloadZip(batch_id)
                        }
                        return null
                    }
                )
            } else {
                clearInterval(interval)
            }
        } catch (e) {
            console.log(e)
            this.setState({loading: false})
            clearInterval(interval)
            message.error('Archivo .zip no encontrado')
        }
    }

    downloadZip = async (batch_id) => {
        try {
            const zipFile = await Storage.get('invoicesBatchZip/' + batch_id + '.zip', {download: false})
            window.open(zipFile)
            this.setState({loading: false, step: 'batchList'})
        } catch (e) {
            console.log(e)
            message.error('No se pudo descargar el lote')
        }

    }


    uploadBatch = async () => {
        this.setState({uploadingCsv: true});
        let response = await Auth.currentSession();
        let user = await Auth.currentUserInfo();

        API.post(
            'test',
            '/root/batch/admin/create',
            {
                headers: {
                    Authorization: response.getIdToken().getJwtToken()
                },
                body: {
                    nroDocumento: this.userData.cuit,
                    user_id: user.username,
                    tipoResponsable: this.userData.id_impositivo,
                    razonSocialCliente: this.userData.razon_social,
                    domicilioComercialCliente: this.userData.domicilio,
                    localidadCliente: this.userData.localidad,
                    provinciaCliente: this.userData.provincia,
                    emailCliente: this.userData.email,
                    fecha_fin: moment(this.state.fechaFin).format('YYYY-MM-DD'),
                    fecha_inicio: moment(this.state.fechaInicio).format('YYYY-MM-DD'),
                    fecha_creacion: moment().format('YYYY-MM-DD'),
                    mes: meses[this.state.periodo] + ' ' + this.state.year,
                    name: this.state.name,
                    userId: user.username,
                    groupuser: 'adminLite'
                }
            }
        )
            .then(response => {
                console.log(response);
                const data = this.state.data.map(data => {
                    data.fecha_factura = moment(this.state.fechaFactura || moment()).format('YYYY-MM-DD');
                    data.servicio_fecha_vencimiento = moment(this.state.fechaFactura || moment()).format('YYYY-MM-DD');
                    return data;
                })
                Storage.put('invoicesBatch/' + response.batch_id + '.csv', JSON.stringify(data), {
                    level: 'public',
                    contentType: 'text/csv'
                }).then(response => {
                    this.componentDidMount();
                    message.success("Lote cargado con exito!")
                    this.setState({uploadingCsv: false, step: 'batchList'})
                })
                    .catch(err => console.log(err))
            })
            .catch(err => console.log(err))
    }

    loadUserData = async () => {
        const [response, user] = await Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]);

        this.userData = await API.get(
            'test',
            '/root/admindashboard/' + user.username,
            {
                headers: {
                    Authorization: response.getIdToken().getJwtToken()
                }
            }
        );
    }

    bajarFacturas = async () => {
        this.setState({loadingBajarFacturas: true});

        const [response] = await Promise.all([
            Auth.currentSession(),
        ]);

        const fechaInicio = this.state.fechaInicioBajarFacturas.format('YYYY-MM-DD')
        const fechaFin = this.state.fechaFinBajarFacturas.format('YYYY-MM-DD')
        const url = '/root/invoices/invoices/cuit/' + this.userData.cuit + '?estado=' + this.state.estado + 
            '&fechaCbteDesde=' + fechaInicio + 
            '&fechaCbteHasta=' + fechaFin

        const facturas = await API.get(
            'test',
            // '/root/invoices/invoices/cuit/' + '33715667369',
            url,
            {
                headers: {
                    Authorization: response.getIdToken().getJwtToken()
                }
            }
        )
        const facturasFiltered = facturas.invoices;

        if(facturasFiltered.length === 0) {
            message.error("No se encuentran facturas dicho estado y rango de fecha seleccionado");
            this.setState({loadingBajarFacturas: false});
            return;
        }

        facturasFiltered.filter(inv => inv.items).forEach(inv => {
            if(inv.items[0]){
                inv.codigoItem1 = inv.items[0].codigo;
                inv.descripcionItem1 = inv.items[0].concepto;
                inv.precioUnitario1 = inv.items[0].precio;
            }
            if(inv.items[1]){
                inv.codigoItem2 = inv.items[1].codigo;
                inv.descripcionItem2 = inv.items[1].concepto;
                inv.precioUnitario2 = inv.items[1].precio;
            }
            if(inv.items[2]){
                inv.codigoItem3 = inv.items[2].codigo;
                inv.descripcionItem3 = inv.items[2].concepto;
                inv.precioUnitario3 = inv.items[2].precio;
            }
        })

        this.setState({loadingBajarFacturas: false, modalBajarFacturasVisible: false, step: 'csvFacturasDownloaded', facturasCSV: facturasFiltered});


    };


    handleCancel() {
        this.setState({loading: false, step: 'batchList', nuevoLoteId: null})
    }

    handleCancelModal = () => {
        this.setState({modalVisible: false, modalBajarFacturasVisible: false})
    }

    saveEditing = () => {
        const csv = [...this.state.csv];
        csv[this.state.indexEditing] = this.state.recordEditing;
        const data = [...this.state.data];
        data[this.state.indexEditing] = this.state.recordEditing;
        this.setState({modalVisible: false, csv, data})
    }


    render() {
        const {getFieldDecorator} = this.props.form;

        if (this.state.loading) {
            return (
                <>
                    <Row/>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                    <Row/>
                </>
            )
        } else if (this.state.step === 'batchList') {

            return (
                <BaseAdminLite
                    selected='load-invoices-batch'>
                    <Row>
                        <Card title={'Facturación masiva'}>
                            <Table
                                columns={this.columns}
                                dataSource={this.state.lotes}
                                scroll={{x: "max-content"}}
                                style={{margin: "20px"}}
                                loading={this.state.loading}
                                pagination={{
                                    showSizeChanger: true,
                                    pageSizeOptions: ['5', '10', '50'],
                                    defaultSizePage: 10,
                                    hideOnSinglePage: true
                                }}
                            />
                        </Card>
                        <Button style={{marginTop: 10, marginBottom: 10}} onClick={() => this.newBatch()}>Generar nuevo
                            Lote</Button>
                        <Button style={{marginTop: 10, marginBottom: 10}} onClick={() => this.setState({modalBajarFacturasVisible: true})}>Descargar
                            CSV de facturas</Button>
                    </Row>
                    <Modal
                        title={"Descargar Facturas"}
                        width={700}
                        visible={this.state.modalBajarFacturasVisible}
                        onOk={this.saveEditing}
                        onCancel={this.handleCancelModal}
                        footer={[
                            <Button key="back" onClick={this.handleCancelModal}>
                                Cancelar
                            </Button>,
                            <Button key="submit" type="primary"
                                    loading={this.state.loadingBajarFacturas}
                                    disabled={!this.state.fechaInicioBajarFacturas || !this.state.fechaFinBajarFacturas || this.state.loadingBajarFacturas}
                                    onClick={this.bajarFacturas}>
                                Descargar
                            </Button>,
                        ]}
                    >
                        <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                            <Form.Item label="Fecha desde">
                                {
                                    getFieldDecorator('fechaInicioBajarFacturas', {
                                        rules: [{
                                            required: true,
                                            message: 'Servicio desde requerido'
                                        }],
                                        value: this.state.fechaInicioBajarFacturas,
                                        initialValue: null
                                    })(<DatePicker
                                        onChange={(date) => this.setState({fechaInicioBajarFacturas: date})}
                                        format="DD-MM-YYYY"
                                        disabledDate={d => !d || d.isAfter(moment())}
                                        locale={locale}
                                        style={{width: 200}}
                                        allowClear={false}
                                    />)
                                }
                            </Form.Item>

                            <Form.Item label="Fecha hasta">
                                {
                                    getFieldDecorator('fechaFinBajarFacturas', {
                                        rules: [{
                                            required: true,
                                            message: 'Servicio hasta requerido'
                                        }],
                                        value: this.state.fechaFinBajarFacturas,
                                        initialValue: null
                                    })(<DatePicker
                                        onChange={(date) => this.setState({fechaFinBajarFacturas: date})}
                                        disabledDate={d => !d || d.isAfter(moment()) || d.isBefore(this.state.fechaInicioBajarFacturas)}
                                        format="DD-MM-YYYY"
                                        locale={locale}
                                        style={{width: 200}}
                                        allowClear={false}
                                    />)
                                }
                            </Form.Item>

                            <Form.Item label="Estado">
                                {
                                    getFieldDecorator('estado', {
                                        value: this.state.estado,
                                        initialValue: this.state.estado
                                    })(<Select style={{width: 100}}
                                                onChange={(value) => {
                                                    this.setState({estado: value})
                                                }}>
                                            <Option key={'EMITTED'} value={'EMITTED'}>{'Emitida'}</Option>
                                            <Option key={'PRESENTED'} value={'PRESENTED'}>{'Presentada'}</Option>
                                            <Option key={'DRAFT'} value={'DRAFT'}>{'Borrador'}</Option>
                                            <Option key={'PENDING_AFIP'} value={'PENDING_AFIP'}>{'Pendiente'}</Option>
                                            <Option key={'REJECTED'} value={'REJECTED'}>{'Rechazada'}</Option>
                                            <Option key={'CANCELED'} value={'CANCELED'}>{'Cancelada'}</Option>
                                       </Select>)
                                }
                            </Form.Item>
                        </div>
                    </Modal>
                </BaseAdminLite>
            )

        } else if (this.state.step === 'batchView') {
            return (
                <BaseAdminLite
                    selected='load-invoices-batch'>
                    <InvoiceTable batchId={this.state.loteIdView}/>
                    <Button type="primary" onClick={() => this.setState({step: 'batchList'})}
                            style={{marginTop: '10px'}}>Volver</Button>
                </BaseAdminLite>)
        } else if (this.state.step === 'newBatch') {


            let loading = this.state.csv.reduce((acc, curr) => {
                return acc ? true : curr.estado === "Procesando"
            }, false)
            //let disabledProcess = (this.state.csv.length === 0 || this.state.csv.reduce((acc, curr) => { return acc ?  curr.estado !== "Sin procesar" : false }, true)) && !loading

            return (
                <BaseAdminLite
                    selected="load-invoices-batch"
                >
                    <Row>
                        <Card title={'Datos del Lote'}>
                            <Col>
                                <Form.Item label="Nombre">
                                    {
                                        getFieldDecorator('name', {
                                            value: this.state.name,
                                            rules: [
                                                {
                                                    required: false,
                                                }
                                            ],
                                            initialValue: ''
                                        })(
                                            <Input style={{width: 300}}
                                                   placeholder="Nombre"
                                                   onChange={(name) => this.setState({name: name.target.value})}
                                                   suffix={
                                                       <Tooltip title="Modificar nombre del lote">
                                                           <Icon type="info-circle"/>
                                                       </Tooltip>
                                                   }
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item label="Periodo">
                                    <div style={{display: 'flex', flexDirection: 'row'}}>
                                    {
                                        getFieldDecorator('periodo', {
                                            value: this.state.periodo,
                                            rules: [
                                                {
                                                    required: true,
                                                }
                                            ],
                                            initialValue: new Date().getMonth()
                                        })(
                                                <Select style={{width: 100}}
                                                        onChange={(value) => {
                                                            this.setState({periodo: value})
                                                        }}>
                                                    {Array.from({length: 12}, (_, i) => i + 1).map(value =>
                                                        <Option key={value}
                                                                value={value}>{meses[value]}</Option>)
                                                    }

                                                </Select>
                                        )
                                    }
                                        {getFieldDecorator('year', {
                                            value: this.state.year,
                                            rules: [
                                                {
                                                    required: true,
                                                }
                                            ],
                                            initialValue: this.state.year
                                        })(
                                            <Select style={{width: 100, marginLeft: 10}}
                                                    onChange={(value) => {
                                                        this.setState({year: value})
                                                    }}>
                                                <Option key={'y1'} value={this.state.years[0]}>{this.state.years[0]}
                                                </Option>
                                                <Option key={'y2'} value={this.state.years[1]}>{this.state.years[1]}
                                                </Option>
                                            </Select>
                                        )

                                        }
                                    </div>
                                </Form.Item>
                            </Col>
                            <Row gutter={8}>
                                <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                                <Form.Item label="Servicio desde">
                                    {
                                        getFieldDecorator('fechaInicio', {
                                            rules: [{
                                                required: true,
                                                message: 'Servicio desde requerido'
                                            }],
                                            value: this.state.fechaInicio,
                                            initialValue: null
                                        })(<DatePicker
                                            onChange={(date) => this.setState({fechaInicio: date})}
                                            format="DD-MM-YYYY"
                                            disabledDate={d => !d || d.isAfter(moment())}
                                            locale={locale}
                                            style={{width: 200}}
                                            allowClear={false}
                                        />)
                                    }
                                </Form.Item>

                                <Form.Item label="Servicio hasta" style={{marginLeft: 10}}>
                                    {
                                        getFieldDecorator('fechaFin', {
                                            rules: [{
                                                required: true,
                                                message: 'Servicio hasta requerido'
                                            }],
                                            value: this.state.fechaFin,
                                            initialValue: null
                                        })(<DatePicker
                                            onChange={(date) => this.setState({fechaFin: date})}
                                            disabledDate={d => !d || d.isAfter(moment()) || d.isBefore(this.state.fechaInicio)}
                                            format="DD-MM-YYYY"
                                            locale={locale}
                                            style={{width: 200}}
                                            allowClear={false}
                                        />)
                                    }
                                </Form.Item>
                                </div>
                            </Row>
                            <Col>
                                <Form.Item label="Fecha de factura">
                                    {
                                        getFieldDecorator('fechaFactura', {
                                            rules: [{
                                                required: false,
                                            }],
                                            value: this.state.fechaFactura,
                                            initialValue: null
                                        })(<DatePicker
                                            onChange={(date) => this.setState({fechaFactura: date})}
                                            disabledDate={d => !d || d.isAfter(moment()) || d.isBefore(moment().subtract(15, 'd'))}
                                            format="DD-MM-YYYY"
                                            locale={locale}
                                            style={{width: 200}}
                                            allowClear={true}
                                        />)
                                    }
                                </Form.Item>
                            </Col>
                        </Card>

                    </Row>

                    <Row>
                        <Card style={{marginTop: 20}}>
                            <CSVReader
                                disabled={!this.state.enableUpload}
                                onFileLoaded={(data) => {
                                    const selectedKeys = [];
                                    let rows = data.map((value, index) => {
                                        value["key"] = index
                                        value['procesar'] = true;
                                        selectedKeys.push(index);
                                        return value
                                    })
                                    console.table(rows);
                                    this.setState({csv: rows, data: data, selectedKeys})
                                }}
                                parserOptions={{
                                    header: true,
                                    skipEmptyLines: true,
                                    transformHeader: header =>
                                        header
                                            .toLowerCase()
                                            .replace(/\W/g, '_')
                                }}
                                cssClass="ant-btn ant-btn-primary"
                                label="Importar CSV"
                                onError={(e) => {
                                    this.setState({csv: []});
                                    console.error(e);
                                    return (
                                        message.error('Error en archivo CSV')
                                    )
                                }}
                            />
                            <Modal
                                title={"Editar"}
                                width={700}
                                visible={this.state.modalVisible}
                                onOk={this.saveEditing}
                                onCancel={this.handleCancelModal}
                                footer={[
                                    <Button key="back" onClick={this.handleCancelModal}>
                                        Cancelar
                                    </Button>,
                                    <Button key="submit" type="primary" onClick={this.saveEditing}>
                                        Guardar
                                    </Button>,
                                ]}
                            >
                                <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                                    {this.state.recordEditing && this.csvHeaders.filter(c => c.label).map(c => (
                                        <div style={{marginTop: 5, marginRight: 10}}>
                                            <label>{c.label}</label><br/>
                                            <Input style={{width: 300}}
                                                   key={c.dataIndex}
                                                   value={this.state.recordEditing[c.dataIndex]}
                                                   onChange={e => {
                                                       const record = {...(this.state.recordEditing)};
                                                       record[c.dataIndex] = e.target.value;
                                                       this.setState({recordEditing: record})
                                                   }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </Modal>
                            <Table
                                columns={this.csvHeaders}
                                dataSource={this.state.csv}
                                rowClassName={(data, index) => data.procesar ? 'procesar' : 'no-procesar'}
                                rowSelection={{
                                    selectedRowKeys: this.state.selectedKeys,
                                    onChange: selectedKeys => this.setState({selectedKeys}),
                                    onSelect: record => {
                                        this.state.csv[record.key].procesar = !this.state.csv[record.key].procesar;
                                        this.setState({csv: [...this.state.csv]})
                                    }
                                }}
                                scroll={{x: "max-content"}}
                                style={{margin: "20px"}}
                            />
                            <Button.Group style={{marginTop: "15px", marginLeft: "15px"}}>
                                <Button
                                    type="primary"
                                    onClick={(e) => this.uploadBatch()}
                                    disabled={this.state.periodo == null || !this.state.fechaInicio || !this.state.fechaFin
                                    || (!this.state.csv || !this.state.csv.some(row => row.procesar))}
                                    loading={this.state.uploadingCsv}
                                >
                                    Subir lote
                                </Button>
                                <Button
                                    loading={loading}
                                    type="primary"
                                    disabled={false}
                                    onClick={() => this.handleCancel()}
                                >
                                    Volver
                                </Button>
                            </Button.Group>
                        </Card>
                    </Row>
                </BaseAdminLite>
            );
        } else if (this.state.step === 'csvDownloaded') {

            return (
                <BaseAdminLite>
                    <Button
                        loading={false}
                        type="primary"
                        disabled={false}
                    >
                        <CSVLink
                            data={this.state.downloadedCSV}
                            headers={headerProcessed}
                            filename={"Lote de facturacion " + this.state.downloadedCSV[0].batchId + ".csv"}
                            style={{marginLeft: '10px'}}
                        >
                            Descargar Lote en CSV
                        </CSVLink>
                    </Button>

                    <Button style={{marginLeft: "5px", marginRight: "5px"}}
                            onClick={() => this.setState({step: "batchList"})}>
                        Volver a tabla de Lotes
                    </Button>
                </BaseAdminLite>
            )
        }  else if (this.state.step === 'csvFacturasDownloaded') {


            return (
                <BaseAdminLite>
                    <Button
                        loading={false}
                        type="primary"
                        disabled={false}
                    >
                        <CSVLink
                            data={this.state.facturasCSV}
                            headers={headerProcessed}
                            filename={"facturas.csv"}
                            style={{marginLeft: '10px'}}
                        >
                            Descargar CSV
                        </CSVLink>
                    </Button>

                    <Button style={{marginLeft: "5px", marginRight: "5px"}}
                            onClick={() => this.setState({step: "batchList"})}>
                        Volver a tabla de Lotes
                    </Button>

                    <InvoiceTable invoices={this.state.facturasCSV}/>
                </BaseAdminLite>
            )
        }
    }
}


const meses = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', "Junio", 'Julio', "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const InvoiceBatch = Form.create({name: 'uploadInvoices'})(LoadInvoicesBatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoiceBatch))

let headerProcessed = [

    {
        label: 'Período',
        title: 'Período',
        key: 'batchName',
        dataIndex: 'batchName'
    },
    {
        label: 'Razon Social emisor',
        title: 'Razon social emisor',
        key: 'razon_social',
        dataIndex: 'razon_social'
    },
    {
        label: 'CUIT emisor',
        title: 'CUIT emisor',
        key: 'userCuit',
        dataIndex: 'userCuit'
    },
    {
        label: 'Tipo comprobante',
        title: 'Tipo comprobante',
        key: 'tipoDeComprobante',
        dataIndex: 'tipoDeComprobante'

    },
    {
        label: 'Punto de Venta',
        title: 'Punto de Venta',
        key: 'puntoVenta',
        dataIndex: 'puntoVenta'

    },
    {
        label: 'Nro Comprobante',
        title: 'Nro Comprobante',
        key: 'nroDeComprobante',
        dataIndex: 'nroDeComprobante'
    },
    {
        label: 'CAE',
        title: 'CAE',
        key: 'cae',
        dataIndex: 'cae'
    },
    {
        label: 'Vencimiento del CAE',
        title: 'Vencimiento del CAE',
        key: 'fechaVencimientoCae',
        dataIndex: 'fechaVencimientoCae'
    },
    {
        label: 'Fecha de Comprobante',
        title: 'Fecha de Comprobante',
        key: 'fecha',
        dataIndex: 'fecha'
    },
    {
        label: 'Servicios desde',
        title: 'Servicios desde',
        key: 'servicio_desde',
        dataIndex: 'servicio_desde'
    },
    {
        label: 'Servicios hasta',
        title: 'Servicios hasta',
        key: 'servicio_hasta',
        dataIndex: 'servicio_hasta'
    },
    {
        label: 'Vencimiento del pago',
        title: 'Vencimiento del pago',
        key: 'servicio_fecha_vencimiento',
        dataIndex: 'servicio_fecha_vencimiento'
    },
    {
        label: 'Código item 1',
        title: 'Código item 1',
        key: 'codigoItem1',
        dataIndex: 'codigoItem1'
    },
    {
        label: 'Descripción ítem 1',
        title: 'Descripción ítem 1',
        key: 'descripcionItem1',
        dataIndex: 'descripcionItem1'
    },
    {
        label: 'Precio unitario ítem 1',
        title: 'Precio unitario ítem 1',
        key: 'precioUnitario1',
        dataIndex: 'precioUnitario1'
    },
    {
        label: 'Código item 2',
        title: 'Código item 2',
        key: 'codigoItem2',
        dataIndex: 'codigoItem2'
    },
    {
        label: 'Descripción ítem 2',
        title: 'Descripción ítem 2',
        key: 'descripcionItem2',
        dataIndex: 'descripcionItem2'
    },
    {
        label: 'Precio unitario ítem 2',
        title: 'Precio unitario ítem 2',
        key: 'precioUnitario2',
        dataIndex: 'precioUnitario2'
    },
    {
        label: 'Código item 3',
        title: 'Código item 3',
        key: 'codigoItem3',
        dataIndex: 'codigoItem3'
    },
    {
        label: 'Descripción ítem 3',
        title: 'Descripción ítem 3',
        key: 'descripcionItem3',
        dataIndex: 'descripcionItem3'
    },
    {
        label: 'Precio unitario ítem 3',
        title: 'Precio unitario ítem 3',
        key: 'precioUnitario3',
        dataIndex: 'precioUnitario3'
    },
    {
        label: 'Monto Total',
        title: 'Monto Total',
        key: 'importeTotal',
        dataIndex: 'importeTotal'
    },
    {
        label: 'Observaciones',
        title: 'Observaciones',
        key: 'observaciones',
        dataIndex: 'observaciones'
    },
]
